import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import BalanceLinkAja from "../../models/BalanceLinkAJa";
import { saveState, loadState, removeState } from "../browser-storage/browser-storage";

type InitialState = {
    balanceLinkAja:  BalanceLinkAja
}
const type = 'balanceLinkAja'

const initialState: InitialState = {
    balanceLinkAja: loadState(type)
}

export const balanceLinkAjaSlice = createSlice({
  name: type,
  initialState: initialState,
  reducers: {
    setBalanceLinkAja: (state, action: PayloadAction<BalanceLinkAja>) => {
      state.balanceLinkAja = action.payload;
      saveState(type, action.payload)
    },
    removeBalanceLinkAja: (state) => {
      state.balanceLinkAja = {};
      removeState(type)
    },
  },
});

// Action creators are generated for each case reducer function
export const { setBalanceLinkAja, removeBalanceLinkAja } =  balanceLinkAjaSlice.actions;

export default  balanceLinkAjaSlice.reducer;
